import { useQuery } from "@outschool/ui-apollo";

import type { LearnerQuizWriterTopicSuggestionsQuery } from "../../generated/graphql";
import { useLearnerAuth } from "../../providers/LearnerAuthProvider";
import { LearnerQuizWriterTopicSuggestions } from "./quizQueries";

export function useQuizWriterTopicSuggestions() {
  const { sessionTokenStore } = useLearnerAuth();
  const isLoggedIn = Boolean(sessionTokenStore?.getLearnerAuth()?.isLoggedIn);

  const { data, loading, error, refetch } =
    useQuery<LearnerQuizWriterTopicSuggestionsQuery>(
      LearnerQuizWriterTopicSuggestions,
      {
        skip: !isLoggedIn,
        fetchPolicy: "cache-and-network",
      },
    );

  return {
    topics: data?.quizWriterTopicSuggestions ?? [],
    loading: isLoggedIn && loading,
    error,
    refetch,
  };
}
